import { render, staticRenderFns } from "./MeshAncestors.vue?vue&type=template&id=07a63e71&scoped=true"
import script from "./MeshAncestors.vue?vue&type=script&lang=js"
export * from "./MeshAncestors.vue?vue&type=script&lang=js"
import style0 from "./MeshAncestors.vue?vue&type=style&index=0&id=07a63e71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a63e71",
  null
  
)

export default component.exports